// extracted by mini-css-extract-plugin
export default {"scrollToButton":"scrollToButton___3bN9n","isFlippedDownside":"isFlippedDownside___2U_Ka"};